module.exports = __webpack_public_path__ + "img/account_group.10bee0c8.svg";